import { createConfigValues } from '@ca/managed-app-config'
import { EnvValues } from './EnvValues'

export type EnvKeys = keyof typeof EnvValues

const configValues = createConfigValues(EnvValues)

/**
 * For web checks if the lowercased param is in the url else checks the env var
 * For native checks if the value is set in Managed App Config else checks the env var
 */
export const {
  getUrlValue,
  getParamOrEnv,
  getBoolean: getEnvBoolean,
  getNumber: getEnvNumber,
  getSetting: getEnvSetting,
} = configValues

/**
 * Managed App Config -> env var. Use `getParamOrEnv` for values that should
 * also be overridable from the url on web.
 */
export default configValues.getValue
